
<div class="input-wrapper" [formGroup]="formGroup" [class.disabled]="disabled" [class.input-error]="f[controlName].invalid && f[controlName].touched" >
    <span class="p-float-label p-input-icon-right">
        <input class="taly-input" dir="ltr"
            [formControlName]="controlName" 
            pInputText 
            [id]="id" 
            [placeholder]="placeholderText" 
            type="text" 
            [attr.inputmode]="inputmodeType" 
            [value]="value" 
            #inputField  
            (change)="onChange(inputField.value)" 
            [disabled]="disabled"
            [maxlength]="max"
        />
        <label [htmlFor]="id" translate class="w-100">{{ label }}</label>
        <ng-container *ngIf="!disabled">
            <i class="pi pi-times" (click)="onReset(inputField)" *ngIf="inputField.value"></i>
        </ng-container>
    </span>
</div>
<div *ngIf="f[controlName].invalid && f[controlName].touched" class="alert">
    <span class="alert-danger" *ngIf="f[controlName].hasError('required')" >
        {{label | translate}} <span class="alert-danger" translate>COMMON.REQUIRED</span>
    </span>
    <span class="alert-danger" *ngIf="!f[controlName].hasError('required') && f[controlName]?.hasError('minlength')"> 
        <span class="alert-danger" translate [translateParams]="{min: min}">COMMON.MIN_LENGTH</span> {{label | translate}}
    </span>
    <span class="alert-danger" *ngIf="!f[controlName].hasError('required') && !f[controlName]?.hasError('minlength') && f[controlName]?.hasError('maxlength')">
        <span class="alert-danger" translate [translateParams]="{max: max}">COMMON.MAX_LENGTH</span> {{label | translate}}
    </span>
    <span class="alert-danger" *ngIf="!f[controlName].hasError('required') && !f[controlName]?.hasError('minlength') && !f[controlName]?.hasError('maxlength') && f[controlName]?.hasError('email')" translate>
        COMMON.INVALID_EMAIL
    </span>
    <span class="alert-danger" *ngIf="!f[controlName].hasError('required') && !f[controlName]?.hasError('minlength') && !f[controlName]?.hasError('maxlength') && !f[controlName]?.hasError('email') && f[controlName]?.hasError('pattern')">
        <span class="alert-danger" translate>COMMON.VALID_ENTER</span> {{label | translate}}
    </span>
</div>
